export function setupProgress(percent: number, duration: number) {
    return {
        percent: percent,
        duration: duration,
        animateValue(htmlElement: HTMLElement, start: number, end: number, duration: number) {
            let startTimestamp = null;
            const step = (timestamp) => {
                if (!startTimestamp) startTimestamp = timestamp;
                const progress = Math.min((timestamp - startTimestamp) / duration, 1);
                const integerFormat = new Intl.NumberFormat();
                htmlElement.style.width = integerFormat.format(Math.floor(progress * (end - start) + start)) + '%';
                if (progress < 1) {
                    window.requestAnimationFrame(step);
                }
            };
            window.requestAnimationFrame(step);
        },
        init() {
            if (this.percent > 1) {
                this.animateValue(this.$refs.progress, 1, this.percent, this.duration);
            }
            document.addEventListener('stats.update', (e: CustomEventInit<{percent: number}>) => {
                if (e.detail.percent !== this.percent) {
                    this.animateValue(this.$refs.progress, this.percent, e.detail.percent, this.duration);
                    this.percent = e.detail.percent;
                }
            });
        },
    };
}
